export enum RuntimeEnvironment {
    DEV = 'DEV',
    TEST = 'TEST',
    PROD = 'PROD',
}
